import React from 'react'

const HappyHourOffer = ({title}) => {
  return (
    <div className="text-[#9DAAA8] hidden md:block">( {title} )</div>
  )
}

export default HappyHourOffer